export default __webpack_public_path__ + "static/media/636.cce27ab6.jpg";